import {getAllDepartment} from '../../api/organize-api'

export const manage_mixin_table = {
    methods: {
        loadTreeData() {
            getAllDepartment().then(({data}) => {
                // console.log("data =>", data)

                this.treeData = []

                let departmentList = data.data
                this.departmentTree = data.data

                departmentList.forEach((topDepartment) => {
                    //添加一级部门
                    let treeTop = {
                        "id": topDepartment.id,
                        "label": topDepartment.name,
                        "comments": topDepartment.comments,
                        "ownerId": topDepartment.ownerId,
                        "parentId": topDepartment.parentId
                    }

                    this.treeData.push(treeTop)

                    //遍历子部门
                    let next = [];
                    let current = []
                    let nextTree = []
                    let currentTree = []

                    current.push(topDepartment)
                    currentTree.push(treeTop)

                    while (current != null) {
                        // console.log("while current => ", current)

                        for (let i = 0; i < current.length; i++) {
                            let subDepartments = current[i].departments

                            if (subDepartments != null) {
                                for (let j = 0; j < subDepartments.length; j++) {
                                    let treeSub = {
                                        "id": subDepartments[j].id,
                                        "label": subDepartments[j].name,
                                        "comments": subDepartments[j].comments,
                                        "ownerId": subDepartments[j].ownerId,
                                        "parentId": subDepartments[j].parentId,
                                        "parentName": subDepartments[j].parentName
                                    }

                                    if (currentTree[i].children == null) {
                                        currentTree[i].children = []
                                    }

                                    currentTree[i].children.push(treeSub)

                                    next.push(subDepartments[j])
                                    nextTree.push(treeSub)

                                    // console.log("i = ", i)
                                    // console.log("j = ", j)
                                    // console.log("subDepartments = ", subDepartments[j].id)
                                }
                            }
                        }

                        if (next.length >= 1) {
                            // console.log("@@@@@@@@@@@@@@@-------------")

                            current = next
                            currentTree = nextTree

                            // console.log("current =>", current)

                            next = []
                            nextTree = []
                        } else {
                            current = null
                            currentTree = null
                        }
                    }
                })
            }).catch((error) => {
                // console.log("error => ", error)
                return Promise.reject("请求部门列表数据错误")
            })
        }
    }
}
